var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit } from '@angular/core';
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { ColorFresnelModel } from 'src/app/edit/models/color-fresnel.model';
var PaintPaletteSwatchComponent = /** @class */ (function () {
    function PaintPaletteSwatchComponent() {
    }
    PaintPaletteSwatchComponent.prototype.ngOnInit = function () {
    };
    PaintPaletteSwatchComponent.prototype.getStyle = function () {
        if (this.colorRecipe) {
            return {
                'background-color': this.makeColor(this.colorRecipe)
            };
        }
        return '';
    };
    PaintPaletteSwatchComponent.prototype.makeColor = function (colorRecipe) {
        var tintColor = colorRecipe.tintColor;
        if (tintColor instanceof ColorFresnelModel) {
            return '#fff';
        }
        else {
            var _a = __read(tintColor, 3), red = _a[0], green = _a[1], blue = _a[2];
            return "rgb(" + red * 255 + ", " + green * 255 + ", " + blue * 255 + ")";
        }
    };
    return PaintPaletteSwatchComponent;
}());
export { PaintPaletteSwatchComponent };
